<template>
  <div v-if="indexData" class="index-stats-view">
    <graph-overview
      v-if="index.dailyIndexTotal"
      title="Index Data"
      y-axis-type="number"
      :zoom.sync="zoom"
      :scale.sync="scale"
      :stats="indexData.indexStats"
      :graph-values="[indexData.dailyIndexTotal]"
    />

    <div v-if="index.dailySalesTotal">
      <br /><br />

      <graph-overview
        title="Sales Volume"
        :date="index.date"
        :zoom.sync="zoom"
        :scale.sync="scale"
        :stats="indexData.stats"
        :graph-values="[indexData.dailySalesTotal]"
      />
    </div>
  </div>
</template>

<script>
import { getIndexData } from '@cardladder/shared/utils/index.util';

import GraphOverview from '@cardladder/shared/components/GraphOverview';

export default {
  components: {
    GraphOverview,
  },

  props: {
    index: Object,
  },

  data() {
    return {
      salesZoom: 92,
      salesScale: 'linear',
    };
  },

  computed: {
    indexData() {
      return getIndexData(this.index, this.zoom);
    },

    zoom: {
      get() {
        return this.$store.state.cardGraphZoom;
      },

      set(value) {
        this.$store.commit('SET_CARD_GRAPH_ZOOM', value);
      },
    },

    scale: {
      get() {
        return this.$store.state.cardGraphScale;
      },

      set(value) {
        this.$store.commit('SET_CARD_GRAPH_SCALE', value);
      },
    },
  },
};
</script>
